import { NO_DISPLAY_DATA } from "../../../src/constants";
import { RegionCode } from "../../types/region";

export type SearchTableIndexValue = {
  tableHeading: string;
  regionCode: string;
};

interface Index {
  tableHeading: string;
  regionCode: RegionCode;
}

export const searchTableIndex: Index[] = [
  {
    tableHeading: "US - N. Virginia",
    regionCode: "us",
  },
  {
    tableHeading: "EU - Dublin",
    regionCode: "eu",
  },
  {
    tableHeading: "AU - Sydney",
    regionCode: "au",
  },
];

export const documentTypes = [
  "template",
  "audit",
  "user",
  "group",
  "organization",
  "subscription",
  "responseset",
  NO_DISPLAY_DATA,
];

export enum DocumentSearch {
  Role = "role_",
  User = "user_",
}

export const ContentLibrarySearchSelectionLimit = 100;
